import { Component, OnInit, Optional, Inject } from '@angular/core';
import { EditDialogsDbindicesService } from './edit-dialogs-dbindices.service';
import { DialogsAlertComponent } from '../../../../../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-dialogs-dbindices',
  templateUrl: './edit-dialogs-dbindices.component.html',
  styleUrls: ['./edit-dialogs-dbindices.component.scss']
})
export class EditDialogsDbindicesComponent implements OnInit {

  /** Subscripción para el guardado de un dbindice */
  $guardar!: Subscription;

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%'};

  mensajeError: boolean = false;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public editDialogsDbindicesService: EditDialogsDbindicesService,
              @Optional() private dialogRef: MatDialogRef<EditDialogsDbindicesComponent>,
              private translateService: TranslateService,
              private dialog: MatDialog) { this.editDialogsDbindicesService.build(); }

  ngOnInit() {
    this.mensajeError = false;
    this.editDialogsDbindicesService.init(this.data).subscribe(result => {
      this.loading = false;
    }, error => {
      this.mensajeError = true;
      this.loading = false;
      console.log("Error: " + error);
    });
  }

  /**
  * @description
  * Guardar el dbindice
  */
  guardar() {
    this.loading = true;
    this.$guardar = this.editDialogsDbindicesService.guardar().subscribe(value => {
      console.log(value);
      // -1: El número del dbindice ya existe
      // false: Error al guardar
      if (value === -1 || value === false) {
        this.errorDbindices('WARNINGS.error_nuevo');
      }
      this.loading = false;
    }, error => {
      console.log(error);
      this.errorDbindices('WARNINGS.error_nuevo');
      this.loading = false;
    });
  }

  /**
  * @description
  * Cierra el dialog dbindices
  */
  aceptar() {
    this.dialogRef.close(true);
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  deshabilitar(){
    let dbindices = this.editDialogsDbindicesService.dbindices;
    let original = this.editDialogsDbindicesService.originalDbindices;
    return this.editDialogsDbindicesService.compare(dbindices, original);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorDbindices(error: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

}
